<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving" saveText="Send"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()" [showFooter]="!value?.messageKey">
  <div>
    <app-message-form
      *ngIf="value"
      (recipientChange)="onRecipientChanged($event)"
      [(formGroupRef)]="formGroupRef"
      [(value)]="value">
    </app-message-form>
  </div>
  <div *ngIf="messageHistory?.length > 0" class="mt-2">
     <div class="form-section-header">
       {{value.messageKey ? 'Previous Message History' : 'Most Recent Message'}}
     </div>
     <div class="mt-1" *ngFor="let message of messageHistory">
       <div class="bold">{{message.subject}}</div>
       <div class="subtle-text">
         <div class="float-left">
           <span *ngIf="message.recipientReadDateTime">Read on&nbsp;&nbsp;{{message.recipientReadDateTime | date}}</span><span *ngIf="!message.recipientReadDateTime">Unread by recipient</span>&nbsp;&nbsp;
         </div>
         <div class="float-right">
           Sent on&nbsp;&nbsp;{{message.createdDateTime | date}}
         </div>
         <div class="clear-both">
         </div>
       </div>
       <div class="mt-1" [innerHtml]="message.htmlContent | safeHtml">
       </div>
     </div>
  </div>
</app-base-entry-dialog-template>
